export default __webpack_public_path__ + "static/media/detail_big_15_2.0d16fb4d.jpg";